//
export default [
    {
        field: 'branchOfficeId',
        type: 'autocompleteObject',
        vuetifyProps: {
            label: 'Sucursal',
        },
        options: {
            data: [],
            text: 'name',
            value: 'id',
        },
        rules: [ 'required' ],
        value: 0,
    },
    {
        field: 'name',
        type: 'text',
        vuetifyProps: {
            label: 'Nombre',
        },
        rules: [ 'required' ],
        value: '',
    },
    {
        field: 'initDateTime',
        type: 'datePicker',
        vuetifyProps: {
            label: 'Inicio',
        },
        rules: [ 'required' ],
        value: 0,
    },
    {
        field: 'finishDateTime',
        type: 'datePicker',
        vuetifyProps: {
            label: 'Término',
        },
        rules: [ 'required' ],
        value: 0,
    },
    {
        field: 'discount',
        type: 'text',
        vuetifyProps: {
            label: 'Descuento',
            suffix: '%',
        },
        rules: [ 'required', 'numeric', 'isNotNegative' ],
        value: 0,
    },
]